import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

const IncidentTableHead = ({
  sortColumn,
  sortOrder,
  handleSort,
  columnSearch,
  onColumnSearchChange,
  setResolutionPendingStatus
}) => {
  return (
    <thead className="text-[#fff] font-normal [&_th]:sticky [&_th]:z-[2] [&_th]:bg-[#1a0020] [&_tr:first-child_th]:top-0 [&_tr:last-child_th]:top-[37px]">
      <tr>
        <th
          onClick={() => handleSort("snowId")}
          className="px-4 pb-[6px] pr-[2px] text-[14px] pt-[10px] text-left whitespace-nowrap w-[14%] cursor-pointer select-none font-normal"
        >
          <span
            className={`flex items-center gap-1   ${
              sortColumn === "snowId" ? " " : ""
            }`}
          >
            Snow Id
            {sortColumn === "snowId"
              ? sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />
              : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("incidentDescription")}
          className="px-4 pb-[6px] pr-[2px] text-[14px] w-[14%] pt-[10px] text-left whitespace-nowrap  cursor-pointer select-none font-normal"
        >
          <span
            className={`flex items-center gap-1   ${
              sortColumn === "incidentDescription" ? " " : ""
            }`}
          >
            Incident Description
            {sortColumn === "incidentDescription"
              ? sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />
              : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("incidentCategory")}
          className="px-4 pb-[6px] pr-[2px] text-[14px] pt-[10px] text-left whitespace-nowrap w-[14%] cursor-pointer select-none font-normal"
        >
          <span
            className={`flex items-center gap-1   ${
              sortColumn === "incidentCategory" ? " " : ""
            }`}
          >
            Incident Category
            {sortColumn === "incidentCategory"
              ? sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />
              : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("assignedTo")}
          className="px-4 pb-[6px] pr-[2px] text-[14px] pt-[10px] text-left whitespace-nowrap w-[14%] cursor-pointer select-none font-normal"
        >
          <span
            className={`flex items-center gap-1   ${
              sortColumn === "assignedTo" ? " " : ""
            }`}
          >
            Assigned to
            {sortColumn === "assignedTo"
              ? sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />
              : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("status")}
          className="px-4 pb-[6px] pr-[2px] text-[14px] pt-[10px] text-left whitespace-nowrap w-[14%] cursor-pointer select-none font-normal"
        >
          <span
            className={`flex items-center gap-1   ${
              sortColumn === "status" ? " " : ""
            }`}
          >
            Status
            {sortColumn === "status"
              ? sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />
              : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("resolutionPendingStatus")}
          className="px-4 pb-[6px] pr-[2px] text-[14px] pt-[10px] text-left whitespace-nowrap w-[14%] cursor-pointer select-none font-normal"
        >
          <span
            className={`flex items-center gap-1   ${
              sortColumn === "resolutionPendingStatus" ? " " : ""
            }`}
          >
            Resolution Pending Status
            {sortColumn === "resolutionPendingStatus"
              ? sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />
              : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>

        <th
          onClick={() => handleSort("createdAt")}
          className="px-4 pb-[6px] pr-[2px] text-[14px] pt-[10px] text-left whitespace-nowrap w-[14%] cursor-pointer select-none font-normal"
        >
          <span
            className={`flex items-center gap-1   ${
              sortColumn === "createdAt" ? " " : ""
            }`}
          >
            Created Date
            {sortColumn === "createdAt"
              ? sortOrder === "asc"
                ? <ArrowUp size={12} />
                : <ArrowDown size={12} />
              : <ArrowUp size={12} className="opacity-30" />}
          </span>
        </th>
      </tr>

      <tr>
        {[
          "snowId",
          "incidentDescription",
          "incidentCategory",
          "assignedTo",
          "status",
          "resolutionPendingStatus",
          "createdAt",
        ].map((key, i) => (
          <th key={i} className="px-4 pt-0 pb-[10px] w-[14px] font-normal">
            <input
              className="w-full text-[12px] pb-[5px] pl-[10px] placeholder-gray-400 bg-white rounded py-2 outline-none font-normal placeholder:font-normal"
              placeholder={key==="createdAt" ? "YYYY-MM-DD" : "Search"}
              value={columnSearch[key] || ""}
              onChange={key==="resolutionPendingStatus" ? (e) => {setResolutionPendingStatus(e.target.value)
                onColumnSearchChange(key, e.target.value)
              } :  (e) => onColumnSearchChange(key, e.target.value)}
            />
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default IncidentTableHead;
